<apx-chart [series]="stackedChart.series" [chart]="stackedChart.chart" [dataLabels]="stackedChart.dataLabels"
[plotOptions]="stackedChart.plotOptions" [responsive]="stackedChart.responsive" [xaxis]="stackedChart.xaxis"
[legend]="stackedChart.legend"  [fill]="stackedChart.fill"></apx-chart>